/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function ArrowDownRight(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path d="M200,88V192a8.00039,8.00039,0,0,1-8,8H88a8.00038,8.00038,0,0,1-5.65723-13.65723L128.686,140,58.34326,69.65723A8.00018,8.00018,0,0,1,69.65674,58.34277L140,128.686l46.34277-46.34327A8.00065,8.00065,0,0,1,200,88Z" />
    </Svg>
  );
}

export default ArrowDownRight;
